import { color } from "@ui";
import type { AllDataFlagMetadata } from "../PointMetadata";
import { ANALYSIS_FLAG_METADATA } from "../PointMetadata";
import t from "../../../../i18n";
import { zIndexChart } from "@ui/Highcharts/BetterHighcharts";
import type { Analysis } from "../../../../api/Analysis";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";

export const ALLDATA_FLAGS_SERIE_ID = "ALLDATA_FLAGS_SERIE_ID";
export const FLAG_AXIS = {
  id: "flagAxis",
  visible: false,
  zoomEnabled: false,
  max: 1,
};

export const flagColorsAllData = {
  activeAnalysis: color.darkNitrogen600,
};

function getAllDataFlagSerie({
  analyses,
  activeAnalyses,
}: {
  analyses: Analysis[];
  activeAnalyses: ActiveAnalysis[];
}): Highcharts.SeriesScatterOptions {
  const activeById = activeAnalyses.reduce<{ [id: string]: boolean }>((acc, a) => {
    acc[a.id] = true;
    return acc;
  }, {});
  const marker = {
    fillColor: flagColorsAllData.activeAnalysis,
  };

  const points = analyses.reduce<Highcharts.PointOptionsObject[]>((acc, analysis) => {
    if (!activeById[analysis.id]) return acc;

    const custom: AllDataFlagMetadata = {
      type: ANALYSIS_FLAG_METADATA,
      group: analysis.group,
      label: analysis.label,
      human: null,
      flagType: "allData",
    };

    acc.push({
      id: `allData-id-${analysis.id}`,
      x: analysis.date,
      y: 0,
      description: t("flags_legend.allData_activeAnalysis"),
      custom,
      color: flagColorsAllData.activeAnalysis,
      marker,
      events: undefined,
    });

    return acc;
  }, []);

  return {
    id: ALLDATA_FLAGS_SERIE_ID,
    name: "",
    data: points,
    yAxis: FLAG_AXIS.id,
    type: "scatter",
    replicateInNavigator: false,
    color: color.lightNitrogen900, // hide hallow effect on point hover
    zIndex: zIndexChart.flagSeries,
    marker: {
      symbol: "rectangle",
      lineWidth: 1,
      lineColor: color.hydrogen,
      radius: 8,
    },
  };
}

export default getAllDataFlagSerie;
